export default __webpack_public_path__ + "static/media/8_bees_selected.ece5521e.png";